import { Credentials } from "./models";

const STORAGE_KEY = "nomoros_uploader_auth_credentials";

interface StoredCredentials {
  token: {
    key: string;
    accessExpiresAt: string;
    refreshExpiresAt: string;
  };
  profile: Credentials["profile"];
}

export function saveCredentials(credentials: Credentials): void {
  const stored: StoredCredentials = {
    token: {
      key: credentials.token.key,
      accessExpiresAt: credentials.token.accessExpiresAt.toISOString(),
      refreshExpiresAt: credentials.token.refreshExpiresAt.toISOString(),
    },
    profile: credentials.profile,
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
}

export function loadCredentials(): Credentials | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as StoredCredentials;
    return {
      token: {
        key: parsed.token.key,
        accessExpiresAt: new Date(parsed.token.accessExpiresAt),
        refreshExpiresAt: new Date(parsed.token.refreshExpiresAt),
      },
      profile: parsed.profile,
    };
  } catch {
    clearCredentials();
    return null;
  }
}

export function clearCredentials(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function isAccessTokenExpired(credentials: Credentials): boolean {
  return credentials.token.accessExpiresAt.getTime() <= Date.now();
}

export function hasValidSession(credentials: Credentials): boolean {
  return credentials.token.refreshExpiresAt.getTime() > Date.now();
}
